import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\Settings\LocaleController::switchMethod
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/locale/switch'
*/
export const switchMethod = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: switchMethod.url(options),
    method: 'patch',
})

switchMethod.definition = {
    methods: ["patch"],
    url: '/locale/switch',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Settings\LocaleController::switchMethod
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/locale/switch'
*/
switchMethod.url = (options?: RouteQueryOptions) => {
    return switchMethod.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\LocaleController::switchMethod
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/locale/switch'
*/
switchMethod.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: switchMethod.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::switchMethod
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/locale/switch'
*/
const switchMethodForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: switchMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::switchMethod
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/locale/switch'
*/
switchMethodForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: switchMethod.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

switchMethod.form = switchMethodForm

/**
* @see \App\Http\Controllers\Settings\LocaleController::dismissSuggestion
* @see app/Http/Controllers/Settings/LocaleController.php:60
* @route '/locale/dismiss-suggestion'
*/
export const dismissSuggestion = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: dismissSuggestion.url(options),
    method: 'post',
})

dismissSuggestion.definition = {
    methods: ["post"],
    url: '/locale/dismiss-suggestion',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Settings\LocaleController::dismissSuggestion
* @see app/Http/Controllers/Settings/LocaleController.php:60
* @route '/locale/dismiss-suggestion'
*/
dismissSuggestion.url = (options?: RouteQueryOptions) => {
    return dismissSuggestion.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\LocaleController::dismissSuggestion
* @see app/Http/Controllers/Settings/LocaleController.php:60
* @route '/locale/dismiss-suggestion'
*/
dismissSuggestion.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: dismissSuggestion.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::dismissSuggestion
* @see app/Http/Controllers/Settings/LocaleController.php:60
* @route '/locale/dismiss-suggestion'
*/
const dismissSuggestionForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: dismissSuggestion.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::dismissSuggestion
* @see app/Http/Controllers/Settings/LocaleController.php:60
* @route '/locale/dismiss-suggestion'
*/
dismissSuggestionForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: dismissSuggestion.url(options),
    method: 'post',
})

dismissSuggestion.form = dismissSuggestionForm

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
export const edit = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/settings/locale',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
edit.url = (options?: RouteQueryOptions) => {
    return edit.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
edit.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
edit.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
const editForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
editForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::edit
* @see app/Http/Controllers/Settings/LocaleController.php:17
* @route '/settings/locale'
*/
editForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Settings\LocaleController::update
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/settings/locale'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

update.definition = {
    methods: ["patch"],
    url: '/settings/locale',
} satisfies RouteDefinition<["patch"]>

/**
* @see \App\Http\Controllers\Settings\LocaleController::update
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/settings/locale'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Settings\LocaleController::update
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/settings/locale'
*/
update.patch = (options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::update
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/settings/locale'
*/
const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Settings\LocaleController::update
* @see app/Http/Controllers/Settings/LocaleController.php:24
* @route '/settings/locale'
*/
updateForm.patch = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PATCH',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

const locale = {
    switch: Object.assign(switchMethod, switchMethod),
    dismissSuggestion: Object.assign(dismissSuggestion, dismissSuggestion),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
}

export default locale